<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" role="tab">
      <b-button block v-b-toggle="`${accordionId}`">
        {{ title }}
        <span class="when-opened"><i class="icofont-rounded-down"></i></span>
        <span class="when-closed"><i class="icofont-rounded-up"></i></span>
      </b-button>
    </b-card-header>

    <b-collapse :id="accordionId" :accordion="accordionGroup" role="tabpanel">
      <b-card-body v-for="(page, i) in pages" :key="i">
        <h3>{{ page.value }}</h3>

        <div class="grid-permissions">
          <div
            v-for="(item, index) in permissionsData[page.key]"
            :key="index"
            class="permission-card"
          >
            <input
              type="checkbox"
              :name="`${page.key}_${index}`"
              v-model="permissions[page.key]"
              :value="item"
            />
            <h3>{{ item.titulo }}</h3>
          </div>
        </div>
      </b-card-body>

      <b-card-body>
        <button
          class="btn btn-default my-3 float-right"
          @click="() => onSave(roleId)"
        >
          Salvar permissões
          <i v-if="!loading" class="icofont-save"></i>
          <b-spinner v-else small variant="light"></b-spinner>
        </button>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'PermissionAccordion',
  props: {
    title: String,
    accordionId: String,
    accordionGroup: String,
    pages: Array,
    permissionsData: Object,
    permissions: Object,
    onSave: Function,
    roleId: Number,
    loading: Boolean,
  },
}
</script>

<style lang="scss">
#accordion-permissions {
  header {
    background-color: #fff;
    background-image: none;
    padding: 10px;
    button {
      background-color: transparent;
      border: none;
      color: #000;
      width: 100%;
      text-align: left;
      border-radius: 0;
      height: auto;
      box-shadow: none;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
    }
  }
  .card {
    padding: 0;
    .card-body {
      padding-bottom: 0;
      h3 {
        font-size: 16px;
        font-weight: 700;
        border: 1px solid #ccc;
        padding: 10px;
      }
      .grid-permissions {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
        padding: 5px 10px;
        @media screen and (max-width: 656px) {
          overflow: scroll;
        }
        .permission-card {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 10px;
          h3 {
            font-size: 16px;
            margin-bottom: 0px;
            font-weight: normal;
            border: none;
          }
        }
      }
    }
  }
  .when-opened,
  .when-closed {
    float: right;
    font-size: 25px;
  }
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
  .line-through {
    position: relative;
    &::after {
      border-bottom: 0.125em solid #000;
      content: '';
      left: 0;
      margin-top: calc(0.125em / 2 * -1);
      position: absolute;
      right: 0;
      top: 50%;
      width: 25px;
      margin: 0 auto;
    }
  }
}

.permissions-card {
  background: #fff;
  padding: 15px;
  transition: all 0.2s ease 0s;
  box-shadow: 0 5px 1px 0 rgb(103 151 255 / 11%),
    0 12px 90px 0 rgb(103 151 255 / 1%);
  border: none;
  border-top: 4px solid transparent;
  background-color: #fff;
  border: 1px solid #deebfd;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      font-size: 18px;
      margin-bottom: 0;
    }
    button {
      color: #fff;
    }
  }
}
</style>
